import { render, staticRenderFns } from "./VerticalWZ.vue?vue&type=template&id=787f8c4f&scoped=true&"
import script from "./VerticalWZ.vue?vue&type=script&lang=ts&"
export * from "./VerticalWZ.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalWZ.vue?vue&type=style&index=0&id=787f8c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787f8c4f",
  null
  
)

export default component.exports